import { graphql } from "relay-runtime"

export const IcdDiagnosisFragment = graphql`
  fragment IcdDiagnosisFragment on IcdDiagnosis {
    id
    isAssociation
    diagnosisCode
    primaryCode
    secondaryCode
    associationType
    text
    linkedConditionIcdDiagnosis {
      diagnosisCode
      text
    }
  }
`
